export default __webpack_public_path__ + "3b0a8896b4854b5b83dcdb473cb76302.svg";